import { useState } from "react";
import Button from "../../../student/components/generic/button";
import { EditContactsModal } from "./EditContactsModal";
import { RenewalTableItem } from "../../utils/quoteUtils";

export const ContactsCell: React.FC<{
  renewal: RenewalTableItem;
}> = ({ renewal }) => {
  const contacts = renewal.contacts || [];
  const head = contacts.slice(0, 2);
  const tail = contacts.slice(2);
  const [showEditContacts, setShowEditContacts] = useState(false);
  return (
    <>
      <span className="group relative block w-full">
        <span className="absolute right-0 top-0 z-10 flex h-full w-full items-center justify-end bg-gradient-to-l from-white from-[100px] to-transparent opacity-0 transition-opacity duration-100 group-hover:opacity-100">
          <Button
            className="!py-0"
            type="link"
            onClick={() => setShowEditContacts(true)}
          >
            Edit contacts
          </Button>
        </span>
        <ul>
          {head.map((c: string) => (
            <li key={c}>{c}</li>
          ))}
          {tail.length > 0 && <li>+{tail.length} more</li>}
        </ul>
      </span>
      <EditContactsModal
        visible={showEditContacts}
        onClose={() => setShowEditContacts(false)}
        renewal={renewal}
      />
    </>
  );
};
